var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsensys(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2200 700",
    style: {
      enableBackground: "new 0 0 2200 700"
    },
    width: 120,
    height: 40,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2C56DD;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Consensys_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main-Logo_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_628_",
    className: "st0",
    d: "M306,574.1c-0.4,0-0.8,0.3-0.8,0.8c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8 C306.7,574.5,306.4,574.1,306,574.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_627_",
    className: "st0",
    d: "M284.6,566.7c-0.9,0-1.5,0.7-1.5,1.5c0,0.9,0.7,1.6,1.5,1.6c0.9,0,1.5-0.7,1.5-1.6 C286.1,567.4,285.4,566.7,284.6,566.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_626_",
    className: "st0",
    d: "M264,557.1c-1.3,0-2.3,1-2.3,2.3c0,1.3,1,2.3,2.3,2.3c1.3,0,2.3-1,2.3-2.3 C266.3,558.1,265.3,557.1,264,557.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_625_",
    className: "st0",
    d: "M244.5,545.3c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1c1.7,0,3.1-1.4,3.1-3.1 C247.6,546.7,246.2,545.3,244.5,545.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_624_",
    className: "st0",
    d: "M226.3,531.6c-2.1,0-3.9,1.7-3.9,3.8c0,2.1,1.7,3.9,3.9,3.9c2.1,0,3.8-1.7,3.8-3.9 C230.1,533.3,228.4,531.6,226.3,531.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_623_",
    className: "st0",
    d: "M209.5,516c-2.5,0-4.6,2.1-4.6,4.6c0,2.6,2.1,4.6,4.6,4.6c2.6,0,4.6-2.1,4.6-4.6 C214.1,518,212.1,516,209.5,516z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_622_",
    className: "st0",
    d: "M194.4,498.7c-3,0-5.4,2.4-5.4,5.4c0,3,2.4,5.4,5.4,5.4c3,0,5.4-2.4,5.4-5.4 C199.8,501.1,197.3,498.7,194.4,498.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_621_",
    className: "st0",
    d: "M181.1,479.9c-3.4,0-6.2,2.8-6.2,6.2c0,3.4,2.8,6.2,6.2,6.2c3.4,0,6.2-2.8,6.2-6.2 C187.3,482.7,184.5,479.9,181.1,479.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_620_",
    className: "st0",
    d: "M177.1,466.5c0-3.8-3.1-6.9-6.9-6.9c-3.8,0-6.9,3.1-6.9,6.9c0,3.8,3.1,6.9,6.9,6.9 C174,473.5,177.1,470.4,177.1,466.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_619_",
    className: "st0",
    d: "M169.7,445.7c0-4.3-3.5-7.7-7.7-7.7c-4.3,0-7.7,3.5-7.7,7.7c0,4.3,3.4,7.7,7.7,7.7 C166.2,453.4,169.7,450,169.7,445.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_618_",
    className: "st0",
    d: "M165.1,424c0-4.7-3.8-8.5-8.5-8.5c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5 C161.2,432.5,165.1,428.7,165.1,424z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_617_",
    className: "st0",
    d: "M163.3,401.8c0-5.1-4.1-9.3-9.2-9.3c-5.1,0-9.3,4.1-9.3,9.3c0,5.1,4.2,9.2,9.3,9.2 C159.2,411,163.3,406.9,163.3,401.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_500_",
    className: "st0",
    d: "M154.5,389.4c5.5,0,10-4.5,10-10c0-5.5-4.5-10-10-10c-5.5,0-10,4.5-10,10 C144.4,384.9,148.9,389.4,154.5,389.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_499_",
    className: "st0",
    d: "M147,357.3c0,6,4.8,10.8,10.8,10.8c6,0,10.8-4.8,10.8-10.8c0-6-4.8-10.8-10.8-10.8 C151.8,346.5,147,351.3,147,357.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_498_",
    className: "st0",
    d: "M470.9,522.6c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7 C471.6,522.9,471.3,522.6,470.9,522.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_497_",
    className: "st0",
    d: "M451.1,532.3c-0.8,0-1.4,0.6-1.4,1.3c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4 C452.5,532.9,451.9,532.3,451.1,532.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_496_",
    className: "st0",
    d: "M430.3,539.9c-1.1,0-2,0.9-2,2c0,1.1,0.9,2.1,2,2.1c1.1,0,2-0.9,2-2.1 C432.4,540.8,431.4,539.9,430.3,539.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_495_",
    className: "st0",
    d: "M408.8,545.2c-1.5,0-2.7,1.2-2.7,2.7c0,1.5,1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7 C411.5,546.5,410.3,545.2,408.8,545.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_494_",
    className: "st0",
    d: "M386.7,548.3c-1.9,0-3.4,1.5-3.4,3.4c0,1.9,1.5,3.4,3.4,3.4c1.9,0,3.4-1.5,3.4-3.4 C390.1,549.8,388.6,548.3,386.7,548.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_493_",
    className: "st0",
    d: "M364.4,549c-2.3,0-4.1,1.8-4.1,4.1c0,2.2,1.8,4.1,4.1,4.1c2.2,0,4.1-1.8,4.1-4.1 C368.5,550.8,366.6,549,364.4,549z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_492_",
    className: "st0",
    d: "M342,547.4c-2.6,0-4.8,2.1-4.8,4.8c0,2.6,2.1,4.8,4.8,4.8c2.6,0,4.8-2.1,4.8-4.8 C346.8,549.5,344.6,547.4,342,547.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_491_",
    className: "st0",
    d: "M319.9,543.3c-3,0-5.4,2.4-5.4,5.4c0,3,2.4,5.5,5.4,5.5c3,0,5.5-2.4,5.5-5.5 C325.3,545.8,322.9,543.3,319.9,543.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_490_",
    className: "st0",
    d: "M298.3,536.5c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.8,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1 C304.5,539.3,301.7,536.5,298.3,536.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_489_",
    className: "st0",
    d: "M277.8,526.9c-3.8,0-6.8,3-6.8,6.8c0,3.8,3,6.8,6.8,6.8c3.7,0,6.8-3.1,6.8-6.8 C284.6,530,281.6,526.9,277.8,526.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_488_",
    className: "st0",
    d: "M266.1,522.2c0-4.1-3.4-7.5-7.5-7.5c-4.1,0-7.5,3.3-7.5,7.5c0,4.1,3.4,7.5,7.5,7.5 C262.7,529.7,266.1,526.3,266.1,522.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_487_",
    className: "st0",
    d: "M241.1,500.1c-4.5,0-8.2,3.7-8.2,8.2c0,4.5,3.7,8.2,8.2,8.2c4.5,0,8.2-3.7,8.2-8.2 C249.3,503.8,245.6,500.1,241.1,500.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_486_",
    className: "st0",
    d: "M225.6,483.3c-4.9,0-8.9,4-8.9,8.9c0,4.9,4,8.9,8.9,8.9c4.9,0,8.9-4,8.9-8.9 C234.4,487.2,230.5,483.3,225.6,483.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_485_",
    className: "st0",
    d: "M212.3,483.7c5.3,0,9.5-4.3,9.5-9.5c0-5.3-4.3-9.5-9.5-9.5c-5.3,0-9.5,4.3-9.5,9.5 C202.8,479.4,207,483.7,212.3,483.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_484_",
    className: "st0",
    d: "M211.6,454.6c0-5.6-4.6-10.2-10.2-10.2c-5.6,0-10.2,4.6-10.2,10.2c0,5.6,4.6,10.2,10.2,10.2 C207.1,464.8,211.6,460.2,211.6,454.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_483_",
    className: "st0",
    d: "M551.1,369.5c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6 C551.7,369.7,551.4,369.5,551.1,369.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_482_",
    className: "st0",
    d: "M544.4,390.2c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2 C545.6,390.8,545.1,390.2,544.4,390.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_481_",
    className: "st0",
    d: "M535.6,410.2c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8 C537.4,411,536.6,410.2,535.6,410.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_480_",
    className: "st0",
    d: "M524.6,429.1c-1.3,0-2.4,1.1-2.4,2.4c0,1.4,1.1,2.4,2.4,2.4c1.3,0,2.4-1.1,2.4-2.4 C527,430.2,525.9,429.1,524.6,429.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_479_",
    className: "st0",
    d: "M511.6,446.7c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3,3.1,3c1.7,0,3.1-1.4,3.1-3 C514.7,448.1,513.3,446.7,511.6,446.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_478_",
    className: "st0",
    d: "M496.8,462.9c-2,0-3.7,1.6-3.7,3.7c0,2,1.6,3.7,3.7,3.7c2,0,3.7-1.6,3.7-3.7 C500.5,464.5,498.8,462.9,496.8,462.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_477_",
    className: "st0",
    d: "M480.3,477.4c-2.3,0-4.2,1.9-4.2,4.3s1.9,4.3,4.2,4.3c2.4,0,4.3-1.9,4.3-4.3 S482.7,477.4,480.3,477.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_476_",
    className: "st0",
    d: "M462.3,490.1c-2.7,0-4.9,2.2-4.9,4.9c0,2.7,2.2,4.9,4.9,4.9c2.7,0,4.9-2.2,4.9-4.9 C467.2,492.3,465,490.1,462.3,490.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_475_",
    className: "st0",
    d: "M442.8,500.4c-3,0-5.5,2.5-5.5,5.5c0,3,2.5,5.5,5.5,5.5c3,0,5.5-2.5,5.5-5.5 C448.2,502.8,445.8,500.4,442.8,500.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_474_",
    className: "st0",
    d: "M421.9,508c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1c3.3,0,6.1-2.7,6.1-6.1 C428,510.7,425.3,508,421.9,508z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_473_",
    className: "st0",
    d: "M400.2,512.8c-3.7,0-6.7,3-6.7,6.7c0,3.7,3,6.7,6.7,6.7c3.7,0,6.7-3,6.7-6.7 C406.9,515.8,403.9,512.8,400.2,512.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_472_",
    className: "st0",
    d: "M378,514.7c-4,0-7.3,3.3-7.3,7.3c0,4,3.3,7.3,7.3,7.3c4,0,7.3-3.3,7.3-7.3 C385.3,518,382,514.7,378,514.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_471_",
    className: "st0",
    d: "M363.5,521.6c0-4.4-3.5-7.9-7.9-7.9c-4.4,0-7.9,3.6-7.9,7.9c0,4.4,3.5,7.9,7.9,7.9 C360,529.5,363.5,526,363.5,521.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_470_",
    className: "st0",
    d: "M342,518.3c0-4.7-3.8-8.5-8.5-8.5c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5 C338.2,526.8,342,523,342,518.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_469_",
    className: "st0",
    d: "M321.1,512.1c0-5-4.1-9.1-9.2-9.1c-5.1,0-9.2,4.1-9.2,9.1c0,5.1,4.1,9.2,9.2,9.2 C317,521.2,321.1,517.1,321.1,512.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_468_",
    className: "st0",
    d: "M301.2,503.1c0-5.4-4.4-9.8-9.8-9.8c-5.4,0-9.8,4.4-9.8,9.8c0,5.4,4.4,9.8,9.8,9.8 C296.8,512.9,301.2,508.5,301.2,503.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_467_",
    className: "st0",
    d: "M499.4,205.7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C498.8,205.5,499.1,205.7,499.4,205.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_466_",
    className: "st0",
    d: "M509.9,226.1c0.7,0,1.2-0.5,1.2-1.2c0-0.7-0.5-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2 C508.6,225.6,509.2,226.1,509.9,226.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_465_",
    className: "st0",
    d: "M518.1,247.6c1,0,1.8-0.8,1.8-1.8c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8 C516.3,246.7,517.1,247.6,518.1,247.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_464_",
    className: "st0",
    d: "M524.2,269.7c1.3,0,2.4-1.1,2.4-2.4c0-1.4-1.1-2.5-2.4-2.5c-1.4,0-2.4,1.1-2.4,2.5 C521.7,268.6,522.8,269.7,524.2,269.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_463_",
    className: "st0",
    d: "M524.8,289.4c0,1.7,1.4,3,3,3c1.7,0,3.1-1.4,3.1-3c0-1.7-1.4-3.1-3.1-3.1 C526.2,286.3,524.8,287.7,524.8,289.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_462_",
    className: "st0",
    d: "M529.3,308c-2,0-3.7,1.6-3.7,3.7c0,2,1.6,3.6,3.7,3.6c2,0,3.7-1.6,3.7-3.6 C532.9,309.7,531.3,308,529.3,308z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_461_",
    className: "st0",
    d: "M528.3,329.8c-2.3,0-4.3,1.9-4.3,4.3c0,2.4,1.9,4.3,4.3,4.3c2.4,0,4.3-1.9,4.3-4.3 C532.6,331.7,530.7,329.8,528.3,329.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_460_",
    className: "st0",
    d: "M525,351.3c-2.7,0-4.9,2.2-4.9,4.9c0,2.7,2.2,4.9,4.9,4.9c2.7,0,4.9-2.2,4.9-4.9 C529.9,353.5,527.7,351.3,525,351.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_459_",
    className: "st0",
    d: "M524.3,377.7c0-3-2.4-5.5-5.5-5.5c-3,0-5.5,2.5-5.5,5.5c0,3,2.5,5.5,5.5,5.5 C521.9,383.2,524.3,380.7,524.3,377.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_458_",
    className: "st0",
    d: "M509.9,392.1c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1 C516,394.9,513.3,392.1,509.9,392.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_457_",
    className: "st0",
    d: "M498.4,410.7c-3.7,0-6.7,3-6.7,6.7c0,3.7,3,6.7,6.7,6.7c3.7,0,6.7-3,6.7-6.7 C505.1,413.7,502.1,410.7,498.4,410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_456_",
    className: "st0",
    d: "M484.4,427.6c-4,0-7.3,3.3-7.3,7.3c0,4,3.3,7.3,7.3,7.3s7.3-3.3,7.3-7.3 C491.8,430.9,488.5,427.6,484.4,427.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_455_",
    className: "st0",
    d: "M468.3,442.5c-4.4,0-7.9,3.6-7.9,7.9c0,4.4,3.5,7.9,7.9,7.9c4.4,0,7.9-3.6,7.9-7.9 C476.3,446.1,472.7,442.5,468.3,442.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_454_",
    className: "st0",
    d: "M450.3,455.2c-4.7,0-8.6,3.8-8.6,8.5c0,4.7,3.8,8.5,8.6,8.5c4.7,0,8.5-3.8,8.5-8.5 C458.9,459,455.1,455.2,450.3,455.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_453_",
    className: "st0",
    d: "M430.8,465.4c-5.1,0-9.2,4.1-9.2,9.2c0,5.1,4.1,9.2,9.2,9.2c5.1,0,9.2-4.1,9.2-9.2 C439.9,469.6,435.8,465.4,430.8,465.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_452_",
    className: "st0",
    d: "M409.9,473c-5.4,0-9.8,4.4-9.8,9.8c0,5.4,4.4,9.8,9.8,9.8c5.4,0,9.8-4.4,9.8-9.8 C419.7,477.4,415.3,473,409.9,473z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_451_",
    className: "st0",
    d: "M346.3,125.6c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C345.7,125.3,345.9,125.6,346.3,125.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_450_",
    className: "st0",
    d: "M367.7,132.8c0.7,0,1.2-0.5,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.5-1.2,1.2 C366.4,132.3,367,132.8,367.7,132.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_449_",
    className: "st0",
    d: "M388.2,142.3c1,0,1.8-0.8,1.8-1.8c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8 C386.4,141.5,387.2,142.3,388.2,142.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_448_",
    className: "st0",
    d: "M407.7,153.9c1.4,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4c-1.3,0-2.5,1.1-2.5,2.4 C405.3,152.8,406.4,153.9,407.7,153.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_447_",
    className: "st0",
    d: "M426,167.4c1.7,0,3-1.4,3-3c0-1.7-1.4-3-3-3c-1.7,0-3.1,1.4-3.1,3 C422.9,166.1,424.3,167.4,426,167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_446_",
    className: "st0",
    d: "M442.7,182.9c2,0,3.7-1.7,3.7-3.7c0-2-1.6-3.7-3.7-3.7c-2,0-3.6,1.6-3.6,3.7 C439.1,181.2,440.7,182.9,442.7,182.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_445_",
    className: "st0",
    d: "M457.9,200c2.3,0,4.3-1.9,4.3-4.3c0-2.4-1.9-4.3-4.3-4.3c-2.4,0-4.3,1.9-4.3,4.3 C453.6,198.1,455.5,200,457.9,200z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_444_",
    className: "st0",
    d: "M471.2,218.6c2.7,0,4.9-2.2,4.9-4.9c0-2.7-2.2-4.9-4.9-4.9c-2.7,0-4.9,2.2-4.9,4.9 C466.3,216.4,468.4,218.6,471.2,218.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_443_",
    className: "st0",
    d: "M482,238.8c3,0,5.5-2.5,5.5-5.5c0-3-2.5-5.5-5.5-5.5c-3,0-5.5,2.4-5.5,5.5 C476.5,236.3,479,238.8,482,238.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_442_",
    className: "st0",
    d: "M484.2,254.1c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1c0-3.4-2.7-6.1-6.1-6.1 C486.9,248,484.2,250.7,484.2,254.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_441_",
    className: "st0",
    d: "M489,275.8c0,3.7,3,6.7,6.7,6.7c3.7,0,6.7-3,6.7-6.7c0-3.7-3-6.7-6.7-6.7 C492,269.1,489,272.1,489,275.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_440_",
    className: "st0",
    d: "M490.9,298.1c0,4,3.3,7.3,7.3,7.3c4,0,7.3-3.3,7.3-7.3c0-4-3.3-7.3-7.3-7.3 C494.1,290.7,490.9,294,490.9,298.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_439_",
    className: "st0",
    d: "M505.7,320.5c0-4.4-3.5-7.9-7.9-7.9c-4.4,0-7.9,3.5-7.9,7.9c0,4.4,3.6,7.9,7.9,7.9 C502.1,328.4,505.7,324.8,505.7,320.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_438_",
    className: "st0",
    d: "M503,342.6c0-4.7-3.8-8.6-8.5-8.6c-4.7,0-8.6,3.8-8.6,8.6c0,4.7,3.8,8.5,8.6,8.5 C499.2,351.1,503,347.3,503,342.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_437_",
    className: "st0",
    d: "M497.4,364.1c0-5.1-4.1-9.2-9.2-9.2c-5.1,0-9.2,4.1-9.2,9.2c0,5,4.1,9.2,9.2,9.2 C493.3,373.2,497.4,369.1,497.4,364.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_436_",
    className: "st0",
    d: "M479.3,374.8c-5.4,0-9.7,4.4-9.7,9.8c0,5.4,4.4,9.8,9.7,9.8c5.4,0,9.8-4.4,9.8-9.8 C489.1,379.2,484.7,374.8,479.3,374.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_435_",
    className: "st0",
    d: "M181.3,177.2c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C180.7,176.9,181,177.2,181.3,177.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_434_",
    className: "st0",
    d: "M201.1,167.4c0.7,0,1.2-0.5,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.5-1.2,1.2 C199.9,166.9,200.4,167.4,201.1,167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_433_",
    className: "st0",
    d: "M221.9,159.7c1,0,1.8-0.8,1.8-1.8c0-1-0.8-1.9-1.8-1.9c-1,0-1.8,0.8-1.8,1.9 C220.1,158.9,220.9,159.7,221.9,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_432_",
    className: "st0",
    d: "M243.5,154.3c1.4,0,2.4-1.1,2.4-2.4c0-1.4-1.1-2.4-2.4-2.4c-1.3,0-2.4,1.1-2.4,2.4 C241,153.2,242.1,154.3,243.5,154.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_431_",
    className: "st0",
    d: "M265.5,151.2c1.7,0,3-1.4,3-3.1c0-1.7-1.4-3-3-3c-1.7,0-3.1,1.4-3.1,3 C262.5,149.8,263.9,151.2,265.5,151.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_430_",
    className: "st0",
    d: "M287.9,150.4c2,0,3.7-1.6,3.7-3.7c0-2-1.6-3.7-3.7-3.7c-2,0-3.7,1.6-3.7,3.7 C284.2,148.8,285.9,150.4,287.9,150.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_429_",
    className: "st0",
    d: "M310.2,152c2.4,0,4.3-1.9,4.3-4.3c0-2.4-1.9-4.3-4.3-4.3c-2.4,0-4.3,1.9-4.3,4.3 C306,150.1,307.9,152,310.2,152z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_428_",
    className: "st0",
    d: "M332.4,155.9c2.7,0,4.9-2.2,4.9-4.9c0-2.7-2.2-4.9-4.9-4.9c-2.7,0-4.9,2.2-4.9,4.9 C327.5,153.8,329.7,155.9,332.4,155.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_427_",
    className: "st0",
    d: "M353.9,162.7c3,0,5.5-2.5,5.5-5.5c0-3-2.5-5.5-5.5-5.5c-3,0-5.5,2.5-5.5,5.5 C348.4,160.2,350.9,162.7,353.9,162.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_426_",
    className: "st0",
    d: "M374.4,172.2c3.4,0,6.1-2.7,6.1-6.1c0-3.4-2.7-6.1-6.1-6.1c-3.4,0-6.1,2.7-6.1,6.1 C368.4,169.5,371.1,172.2,374.4,172.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_425_",
    className: "st0",
    d: "M386.9,177.6c0,3.7,3,6.7,6.7,6.7c3.7,0,6.7-3,6.7-6.7c0-3.7-3-6.7-6.7-6.7 C389.9,170.9,386.9,173.9,386.9,177.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_424_",
    className: "st0",
    d: "M411.1,198.9c4,0,7.3-3.3,7.3-7.3c0-4-3.3-7.3-7.3-7.3c-4.1,0-7.3,3.3-7.3,7.3 C403.8,195.6,407.1,198.9,411.1,198.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_423_",
    className: "st0",
    d: "M426.7,215.6c4.4,0,7.9-3.6,7.9-7.9c0-4.4-3.6-7.9-7.9-7.9c-4.4,0-7.9,3.6-7.9,7.9 C418.7,212.1,422.3,215.6,426.7,215.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_422_",
    className: "st0",
    d: "M439.9,217.1c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5 C448.5,221,444.7,217.1,439.9,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_421_",
    className: "st0",
    d: "M441.7,245.3c0,5,4.1,9.1,9.1,9.1c5.1,0,9.1-4.1,9.1-9.1c0-5.1-4.1-9.2-9.1-9.2 C445.7,236.1,441.7,240.2,441.7,245.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_420_",
    className: "st0",
    d: "M449.2,266.1c0,5.4,4.4,9.8,9.8,9.8c5.4,0,9.7-4.4,9.7-9.8c0-5.4-4.4-9.8-9.7-9.8 C453.6,256.3,449.2,260.7,449.2,266.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_419_",
    className: "st0",
    d: "M464.4,277.4c-5.7,0-10.4,4.7-10.4,10.4c0,5.7,4.6,10.4,10.4,10.4c5.7,0,10.4-4.6,10.4-10.4 C474.8,282.1,470.1,277.4,464.4,277.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_418_",
    className: "st0",
    d: "M101.2,328.6c-0.6,0-1.2,0.5-1.2,1.1c0,0.6,0.5,1.1,1.2,1.1c0.6,0,1.1-0.5,1.1-1.1 C102.3,329.1,101.8,328.6,101.2,328.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_417_",
    className: "st0",
    d: "M107.8,306.1c-1.3,0-2.3,1-2.3,2.3c0,1.3,1,2.3,2.3,2.3c1.3,0,2.3-1,2.3-2.3 C110.1,307.1,109.1,306.1,107.8,306.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_416_",
    className: "st0",
    d: "M120.1,287.8c0-1.9-1.6-3.5-3.5-3.5c-1.9,0-3.4,1.5-3.4,3.5c0,1.9,1.5,3.5,3.4,3.5 C118.6,291.3,120.1,289.7,120.1,287.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_415_",
    className: "st0",
    d: "M127.6,272.9c2.5,0,4.6-2.1,4.6-4.6c0-2.5-2.1-4.6-4.6-4.6c-2.5,0-4.6,2.1-4.6,4.6 C123,270.9,125.1,272.9,127.6,272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_414_",
    className: "st0",
    d: "M140.6,255.8c3.2,0,5.8-2.6,5.8-5.8c0-3.2-2.6-5.8-5.8-5.8c-3.2,0-5.7,2.6-5.7,5.8 C134.9,253.3,137.4,255.8,140.6,255.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_413_",
    className: "st0",
    d: "M155.4,240.2c3.8,0,6.9-3.1,6.9-6.9c0-3.8-3.1-6.9-6.9-6.9c-3.8,0-6.9,3.1-6.9,6.9 C148.5,237.1,151.6,240.2,155.4,240.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_412_",
    className: "st0",
    d: "M171.9,226.2c4.4,0,8-3.6,8-8.1c0-4.4-3.6-8.1-8-8.1c-4.4,0-8.1,3.6-8.1,8.1 C163.9,222.6,167.5,226.2,171.9,226.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_411_",
    className: "st0",
    d: "M189.9,214.1c5.1,0,9.2-4.1,9.2-9.2c0-5.1-4.1-9.2-9.2-9.2c-5.1,0-9.2,4.1-9.2,9.2 C180.7,210,184.8,214.1,189.9,214.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_410_",
    className: "st0",
    d: "M209.4,204.2c5.7,0,10.3-4.7,10.3-10.4c0-5.7-4.6-10.3-10.3-10.3c-5.7,0-10.4,4.6-10.4,10.3 C199,199.5,203.7,204.2,209.4,204.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_409_",
    className: "st0",
    d: "M230.1,196.9c5.8,0,10.5-4.3,11.3-9.8c2.3,3.3,6.1,5.4,10.3,5.4c4.9,0,9.1-2.8,11.2-6.8 c2.5,3.3,6.5,5.5,11,5.5c4.1,0,7.7-1.8,10.2-4.5c2.7,3.8,7.1,6.3,12.2,6.3c3.2,0,6.1-1,8.5-2.7c0.6,0.9,1.2,1.7,1.9,2.5 c-3.8,0.4-7.2,2-9.8,4.5c-2.8-2.6-6.6-4.2-10.8-4.2c-5.3,0-10,2.6-12.9,6.6c-2.6-2-5.8-3.2-9.3-3.2c-6.1,0-11.3,3.6-13.7,8.8 c-2.3-1.6-5-2.5-8-2.5c-6.8,0-12.4,4.7-13.9,11c-2-1.2-4.4-2-6.9-2c-7.4,0-13.4,6-13.4,13.3c0,0,0,0,0,0c-1.8-1.1-4-1.7-6.2-1.7 c-6.9,0-12.5,5.6-12.5,12.5c0,1.2,0.2,2.4,0.5,3.5c-1.8-1.1-3.8-1.7-6-1.7c-6.4,0-11.6,5.2-11.6,11.6c0,6.4,5.2,11.6,11.6,11.6 c6.4,0,11.6-5.2,11.6-11.6c0-1-0.2-1.9-0.4-2.9c2,1.3,4.3,2,6.8,2c6.7,0,12.2-5.3,12.4-12c2.1,1.3,4.5,2.1,7.1,2.1 c0.2,0,0.5,0,0.7,0c-2.8,2.5-4.6,6.1-5,10.1c-0.9-0.2-1.8-0.3-2.7-0.3c-8.1,0-14.6,6.6-14.6,14.6c0,0.6,0,1.1,0.1,1.7 c-0.5-0.1-1.1-0.1-1.6-0.1c-7.7,0-13.9,6.2-13.9,13.9c0,1.5,0.2,3,0.7,4.4c-0.3,0-0.6,0-0.8,0c-7.2,0-13.1,5.9-13.1,13.1 c0,2.5,0.7,4.8,2,6.9c-0.1,0-0.2,0-0.4,0c-6.8,0-12.3,5.5-12.3,12.3c0,3.6,1.5,6.8,3.9,9c-0.2,0-0.4-0.1-0.5-0.1 c-6.4,0-11.6,5.2-11.6,11.6c0,6.4,5.2,11.6,11.6,11.6c6.4,0,11.6-5.2,11.6-11.6c0-3.2-1.3-6.1-3.5-8.2c0.3,0,0.5,0,0.8,0 c3.6,0,6.8-1.5,9-4c0,0.1,0,0.3,0,0.4c0,3.2,1,6.1,2.8,8.5c-5.3,1.9-9,6.9-9,12.8c0,4.1,1.9,7.8,4.8,10.4 c-4.5,2-7.6,6.5-7.6,11.7c0,5,2.8,9.3,6.9,11.5c-4,2-6.7,6.1-6.7,10.9c0,5.8,4.1,10.7,9.5,11.9c-3.7,1.9-6.4,5.8-6.4,10.3 c0,6.4,5.2,11.6,11.6,11.6c0.7,0,1.4-0.1,2.1-0.2c-4.4,1.4-7.6,5.5-7.6,10.3c0,6,4.9,10.9,10.9,10.9c6,0,10.9-4.9,10.9-10.9 c0-6-4.9-10.9-10.9-10.9c-0.7,0-1.3,0.1-2,0.2c4.7-1.5,8.2-5.8,8.2-11c0-0.3-0.1-0.5-0.1-0.8c1.8,2,4.2,3.4,6.8,4 c-1.9,2.2-3.1,5.1-3.1,8.3c0,7.1,5.7,12.8,12.8,12.8c0.1,0,0.2,0,0.3,0c-1.5,2-2.3,4.5-2.3,7.1c0,6.7,5.5,12.2,12.2,12.2 c1.2,0,2.4-0.2,3.5-0.5c-1.2,1.8-1.9,4-1.9,6.4c0,6.4,5.2,11.6,11.6,11.6c2.7,0,5.2-1,7.2-2.6c-1.6,1.9-2.7,4.4-2.7,7.1 c0,6.1,4.9,11,11,11c6.1,0,11-4.9,11-11c0-2.9-1.2-5.6-3-7.6c1.5,0,2.9-0.3,4.2-0.7c0,0,0,0.1,0,0.2c0,5.2,3,9.7,7.3,11.9 c-0.6-0.1-1.3-0.2-2-0.2c-5.7,0-10.4,4.6-10.4,10.4c0,5.7,4.6,10.4,10.4,10.4c5.7,0,10.4-4.6,10.4-10.4c0-3.9-2.2-7.3-5.5-9.1 c1,0.3,2.1,0.4,3.2,0.4c2.6,0,5-0.8,7.1-2c0.5,6.6,6,11.7,12.8,11.7c3.6,0,6.9-1.5,9.2-4c0.9,5.8,6,10.3,12.1,10.3 c4.6,0,8.7-2.6,10.7-6.5c1.1,5.3,5.8,9.3,11.4,9.3c6,0,10.8-4.5,11.5-10.4c0.4,5.7,5.1,10.2,10.9,10.2c6.1,0,11-4.9,11-11 c0-6-4.8-10.8-10.7-10.9c1-1,1.8-2.2,2.5-3.5c2.4,2.5,5.8,4,9.6,4c1.4,0,2.8-0.2,4.1-0.6c-2.7,1.9-4.6,5-4.6,8.6 c0,5.7,4.7,10.4,10.4,10.4c5.7,0,10.4-4.6,10.4-10.4c0-5.7-4.6-10.4-10.4-10.4c-1.1,0-2,0.2-3,0.5c3.1-1.8,5.3-4.9,6.1-8.5 c2.2,1.9,5.1,3,8.3,3c7.1,0,12.8-5.7,12.8-12.8c0-0.1,0-0.2,0-0.3c2,1.5,4.5,2.3,7.1,2.3c6.7,0,12.2-5.5,12.2-12.2 c0-1.2-0.2-2.4-0.5-3.5c1.8,1.2,4,2,6.4,2c6.4,0,11.6-5.2,11.6-11.6c0-2.7-1-5.2-2.6-7.2c1.9,1.7,4.4,2.7,7.1,2.7 c6.1,0,11-4.9,11-11c0-6.1-4.9-11-11-11c-2.9,0-5.6,1.2-7.6,3.1c0-1.5-0.3-2.9-0.7-4.2c0,0,0.1,0,0.1,0c5.2,0,9.7-3,12-7.3 c-0.1,0.7-0.2,1.3-0.2,2c0,5.7,4.6,10.4,10.4,10.4c5.7,0,10.4-4.6,10.4-10.4c0-5.7-4.7-10.4-10.4-10.4c-4,0-7.3,2.2-9.1,5.5 c0.3-1,0.4-2.1,0.4-3.2c0-2.6-0.8-5-2-7.1c6.6-0.5,11.7-6,11.7-12.7c0-3.6-1.5-6.9-4-9.2c5.8-0.9,10.3-6,10.3-12 c0-4.7-2.6-8.7-6.4-10.8c5.3-1.1,9.3-5.8,9.3-11.4c0-6-4.5-10.9-10.4-11.5c5.7-0.4,10.2-5.1,10.2-10.9c0-6.1-4.9-11-11-11 c-6.1,0-11,4.9-11,11c0,5.6,4.3,10.2,9.8,10.9c-6,0.4-10.8,5.4-10.8,11.5c0,4.4,2.5,8.1,6,10.1c-5.7,1-10.1,6-10.1,12 c0,3.3,1.4,6.4,3.6,8.6c-6.3,0.9-11.1,6.2-11.1,12.7c0,2.4,0.6,4.6,1.8,6.5c-7.1,0.4-12.7,6.2-12.7,13.4c0,1.3,0.2,2.6,0.6,3.9 c-0.2,0-0.4,0-0.6,0c-7.8,0-14,6.3-14,14c0,0.3,0,0.7,0.1,1c-0.7-0.1-1.5-0.2-2.2-0.2c-7.4,0-13.5,5.5-14.5,12.5 c-1.3-0.3-2.6-0.5-4-0.5c-6.1,0-11.4,3.6-13.8,8.8c-3-2.4-6.9-3.5-10.9-2.8c-4.5,0.8-8,3.8-9.7,7.7c-2.9-3.1-7.2-4.8-11.7-4.2 c-4.4,0.6-8,3.3-10,7c-2.4-3.1-6.2-5-10.4-5c-3.9,0-7.4,1.6-9.9,4.2c-1.5-3.4-4.5-6.2-8.4-7.3c-4.1-1.2-8.4-0.4-11.6,1.9 c-0.9-3.9-3.4-7.3-7.3-9.2c-3.7-1.8-7.8-1.7-11.3-0.1c-0.1-3.8-1.8-7.5-5.1-10.1c-3.1-2.5-6.9-3.3-10.5-2.7 c0.9-3.7,0.1-7.8-2.3-11.1c-2.6-3.5-6.6-5.3-10.6-5.4c1.6-3.6,1.5-7.9-0.4-11.6c-1.8-3.4-4.9-5.7-8.3-6.7 c2.2-2.8,3.2-6.5,2.6-10.3c-0.7-4.2-3.2-7.6-6.5-9.5c3.2-2.5,5.3-6.4,5.3-10.8c0-4-1.8-7.5-4.6-10c3.4-1.7,6-4.8,7-8.8 c1-3.9,0.1-7.9-2.1-11c3.5-0.8,6.7-3,8.7-6.3c2-3.6,2.3-7.7,1-11.3c3.9,0.2,7.9-1.3,10.7-4.5c2.8-3.1,3.8-7.1,3.3-11 c3.6,0.9,7.6,0.3,10.9-2c3.4-2.4,5.4-6,5.7-9.8c3.4,1.8,7.6,2.1,11.5,0.5c3.6-1.5,6.2-4.4,7.4-7.8c2.7,2.5,6.4,3.8,10.4,3.4h0 c4.3-0.4,7.9-2.8,10-6.2c2.2,3.2,5.8,5.4,10,5.7c4,0.3,7.7-1.2,10.4-3.8c1.4,3.5,4.3,6.5,8.3,7.8c4,1.4,8.3,0.7,11.6-1.5 c0.7,3.8,3.1,7.3,6.8,9.3h0c3.1,1.7,6.5,2,9.6,1.3c0.4,0.5,0.8,1,1.1,1.4c0.2,2.9,1.3,5.7,3.4,8c0.1,0.1,0.2,0.2,0.3,0.3 c6.9,7.2,22.8,24.6,19.8,47.9c-0.8,5.8,2.5,8.7,6.7,4.3c25.3-27.2,21.3-60.7,20.7-64.6c-0.1-2.6-0.7-5-1.6-7.3 c0.3-1.4,0.4-2.9,0.4-4.4c0-7-3.4-13.3-8.6-17.2c0.2-1.3,0.4-2.6,0.4-3.9c0-8.7-5.4-16.1-13-19.2c-0.2-9.7-7.4-17.7-16.7-19.2 c-1.6-8.8-9.3-15.4-18.5-15.4c-0.3,0-0.7,0-1,0c-2.3-7.2-9-12.3-17-12.3c-1.6,0-3.1,0.2-4.5,0.6c-2.7-5.8-8.5-9.9-15.4-9.9 c-2.7,0-5.2,0.6-7.4,1.7c-2.8-4.7-7.9-7.9-13.8-7.9c-3.8,0-7.2,1.3-9.9,3.5c-2.7-3.7-7.1-6.2-12.1-6.2c-4.7,0-8.9,2.2-11.7,5.6 c-2.5-3.1-6.4-5.1-10.7-5.1c-5.6,0-10.4,3.3-12.5,8.1c-2.3-2.7-5.8-4.5-9.7-4.5c-6.5,0-11.9,4.9-12.6,11.3 c-2.1-2.8-5.4-4.6-9.1-4.6c-6.4,0-11.5,5.2-11.5,11.5C218.6,191.8,223.8,196.9,230.1,196.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_408_",
    className: "st0",
    d: "M152.8,493.8c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9 C153.7,494.2,153.3,493.8,152.8,493.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_407_",
    className: "st0",
    d: "M142.4,473.1c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8 C144.2,473.9,143.4,473.1,142.4,473.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_406_",
    className: "st0",
    d: "M134.1,451.4c-1.5,0-2.7,1.2-2.7,2.7c0,1.5,1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7 C136.8,452.6,135.6,451.4,134.1,451.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_405_",
    className: "st0",
    d: "M128.1,429c-2,0-3.6,1.6-3.6,3.6c0,2,1.6,3.6,3.6,3.6c2,0,3.6-1.6,3.6-3.6 C131.6,430.6,130,429,128.1,429z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_404_",
    className: "st0",
    d: "M128.8,410.5c0-2.5-2-4.5-4.4-4.5c-2.5,0-4.5,2-4.5,4.5c0,2.5,2,4.4,4.5,4.4 C126.8,414.9,128.8,413,128.8,410.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_403_",
    className: "st0",
    d: "M128.3,388.2c0-2.9-2.4-5.3-5.3-5.3c-2.9,0-5.3,2.4-5.3,5.3c0,3,2.4,5.4,5.3,5.4 C125.9,393.5,128.3,391.1,128.3,388.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_402_",
    className: "st0",
    d: "M117.7,365.8c0,3.4,2.8,6.2,6.2,6.2c3.4,0,6.2-2.8,6.2-6.2c0-3.5-2.8-6.2-6.2-6.2 C120.5,359.6,117.7,362.3,117.7,365.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_401_",
    className: "st0",
    d: "M127.3,350.8c3.9,0,7.1-3.2,7.1-7.1c0-3.9-3.2-7.1-7.1-7.1c-3.9,0-7.1,3.2-7.1,7.1 C120.1,347.6,123.3,350.8,127.3,350.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_400_",
    className: "st0",
    d: "M133.4,314.1c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8 C141.4,317.7,137.8,314.1,133.4,314.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_399_",
    className: "st0",
    d: "M142.3,310.5c4.9,0,8.9-4,8.9-8.9c0-4.9-4-8.9-8.9-8.9c-4.9,0-8.9,4-8.9,8.9 C133.4,306.5,137.4,310.5,142.3,310.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_398_",
    className: "st0",
    d: "M153.8,292.2c5.4,0,9.8-4.4,9.8-9.8c0-5.4-4.4-9.8-9.8-9.8c-5.4,0-9.8,4.4-9.8,9.8 C144,287.8,148.4,292.2,153.8,292.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_397_",
    className: "st0",
    d: "M178.5,264.9c0-5.9-4.8-10.7-10.7-10.7c-5.9,0-10.7,4.8-10.7,10.7c0,5.9,4.8,10.7,10.7,10.7 C173.7,275.6,178.5,270.8,178.5,264.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_385_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_396_",
    className: "st0",
    d: "M728,435.3c-11.6,0-22.7-2.3-33-6.7c-10.3-4.4-19.3-10.6-26.9-18.2 c-7.6-7.6-13.7-16.8-18.1-27.1c-4.4-10.3-6.7-21.5-6.7-33.1c0-11.7,2.2-22.9,6.7-33.2c4.4-10.3,10.5-19.4,18.1-27.1 c7.6-7.6,16.6-13.8,26.8-18.3c10.3-4.5,21.4-6.8,33.1-6.8c11.8,0,23.1,2.3,33.5,6.9c10.3,4.6,19.5,10.9,27.2,18.9 c1.7,1.7,2.9,3.8,3.8,6.3c1,2.9,0.6,5.8-1.1,8.4c-1.9,2.9-4.7,4.5-8.3,4.7c0,0-0.1,0-0.1,0c-4,0-6.7-1.2-9-3.4 c-5.8-4.9-12.9-9.7-20.8-13.8c-7.8-4-16.2-6.1-25.1-6.1c-8.6,0-16.9,1.7-24.6,5c-7.6,3.4-14.4,8-20,13.8 c-5.6,5.8-10.2,12.7-13.4,20.3c-3.3,7.7-4.9,15.9-4.9,24.6c0,8.6,1.7,16.9,4.9,24.6c3.2,7.6,7.7,14.4,13.4,20.1 c5.6,5.7,12.3,10.3,20,13.6c7.7,3.3,15.9,5,24.5,5c9.1,0,17.8-1.8,25.7-5.3c7.8-3.5,14.8-8.4,20.5-14.6c1.7-2,4-3.3,6.8-3.9 c0.8-0.2,1.7-0.3,2.5-0.3c2,0,3.9,0.6,5.6,1.8c2.8,2.3,4.1,5.2,4.1,8.7c0,3.4-1,6.3-3.1,8.5c-7.8,8.5-17.1,15.2-27.7,19.9 C751.8,432.9,740.2,435.3,728,435.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_393_",
    className: "st0",
    d: "M905.2,435.1c-11.6,0-22.8-2.3-33.1-6.7c-10.3-4.4-19.3-10.5-26.9-18.1 c-7.6-7.6-13.7-16.6-18.1-26.9c-4.4-10.2-6.6-21.4-6.6-33c0-11.7,2.2-22.8,6.6-33c4.4-10.2,10.5-19.3,18.1-27 c7.5-7.7,16.6-13.8,26.9-18.2c10.3-4.4,21.4-6.7,33.1-6.7c11.6,0,22.7,2.2,33,6.7c10.3,4.4,19.4,10.6,27,18.2 c7.7,7.7,13.8,16.7,18.2,27c4.4,10.3,6.7,21.4,6.7,33c0,11.7-2.3,22.8-6.7,33c-4.4,10.2-10.5,19.3-18.2,26.9 c-7.7,7.6-16.8,13.7-27,18.1C928,432.8,916.9,435.1,905.2,435.1z M905.2,287.3c-8.6,0-16.8,1.7-24.5,4.9 c-7.7,3.3-14.4,7.8-20,13.5c-5.7,5.8-10.2,12.6-13.4,20.2c-3.2,7.7-4.9,15.9-4.9,24.6c0,8.7,1.6,16.9,4.9,24.5 c3.2,7.7,7.7,14.4,13.4,20c5.6,5.6,12.3,10.1,20,13.4c7.6,3.3,15.9,4.9,24.5,4.9c8.7,0,16.9-1.6,24.5-4.9 c7.7-3.3,14.5-7.8,20.2-13.4c5.7-5.6,10.2-12.3,13.5-20c3.2-7.6,4.9-15.9,4.9-24.5c0-8.7-1.6-16.9-4.9-24.5 c-3.3-7.7-7.8-14.4-13.5-20.2c-5.7-5.7-12.5-10.2-20.2-13.5C922.1,288.9,913.8,287.3,905.2,287.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_392_",
    className: "st0",
    d: "M1140.2,435.6c-3,0-5.6-1.1-7.7-3.2c-2.1-2.1-3.2-4.7-3.2-7.7v-97.2c0-5.6-1-10.8-3.2-15.8 c-2.2-4.9-5.1-9.3-8.9-13.1c-3.8-3.7-8.2-6.7-13.1-8.9c-4.9-2.2-10.2-3.2-15.8-3.2c-5.6,0-10.8,1.1-15.8,3.2 c-4.9,2.1-9.3,5.1-12.9,8.9c-3.7,3.8-6.6,8.2-8.8,13.1c-2.1,5-3.2,10.3-3.2,15.8v97.2c0,3-1.1,5.6-3.2,7.7c-2,2.1-4.7,3.2-7.7,3.2 c-3.1,0-5.7-1.1-7.8-3.2c-2.1-2.1-3.2-4.7-3.2-7.7v-97.2c0-8.5,1.6-16.7,4.9-24.4c3.2-7.7,7.7-14.4,13.4-20 c5.6-5.7,12.3-10.2,19.9-13.5c7.6-3.3,15.8-5,24.4-5c8.6,0,16.8,1.7,24.4,5c7.6,3.2,14.3,7.8,19.9,13.4 c5.6,5.6,10.2,12.3,13.5,19.9c3.3,7.6,5,15.8,5,24.4v97.2c0,3-1,5.6-3.1,7.7C1145.8,434.5,1143.2,435.6,1140.2,435.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_391_",
    className: "st0",
    d: "M1247.5,435.6c-8.4,0-16.3-1.4-23.6-4c-7.3-2.7-13.8-6.4-19.4-11.2 c-5.6-4.8-10-10.4-13.2-16.7c-3.2-6.4-4.8-13.3-4.8-20.6c0-2.8,1-5.3,3-7.3c2-2,4.5-3.1,7.4-3.1c2.8,0,5.3,1,7.3,3 c2,2,3,4.5,3,7.4c0,4.3,1,8.3,3,12.1c2,3.8,4.8,7.2,8.4,10c3.5,2.8,7.8,5.1,12.7,6.8c4.9,1.7,10.3,2.5,15.9,2.5 c5.6,0,11-0.9,16-2.5c5-1.7,9.4-4,13.1-6.9c3.7-2.8,6.5-6.1,8.6-10c1.9-3.6,2.8-7.7,2.5-11.9c-0.3-4-1.6-7.7-3.7-11.1 c-2.2-3.5-5.1-6.8-8.6-9.5c-3.5-2.8-7.6-5.1-12.3-7c-4.5-1.8-9.5-3.2-14.6-4.1c-7.2-0.5-14.4-1.9-21.2-4.2 c-6.8-2.3-12.9-5.3-18.1-9c-5.2-3.7-9.5-8.1-12.7-13.1c-3.3-5.1-5-10.9-5-17.1c0-6.2,1.6-12,4.6-17.3c3-5.2,7.2-9.8,12.5-13.7 c5.2-3.8,11.3-6.9,18.2-9.2c6.9-2.2,14.3-3.4,22.1-3.4c7.8,0,15.2,1.1,22.1,3.4c6.9,2.3,13,5.3,18.2,9.2c5.3,4,9.5,8.6,12.5,13.7 c3.1,5.3,4.7,11.1,4.7,17.3c0,3-1.1,5.6-3.2,7.7c-2.1,2.1-4.7,3.2-7.7,3.2c-3.1,0-5.7-1.2-7.7-3.4c-1.9-2.1-2.9-4.9-3.2-8.3 c-0.1-2.5-1-5-2.8-7.3c-1.9-2.5-4.3-4.8-7.5-6.8c-3.3-2.1-7.1-3.7-11.4-4.9c-4.4-1.2-9.1-1.8-13.8-1.8c-5,0-9.8,0.6-14.3,1.8 c-4.4,1.2-8.2,2.8-11.4,4.9c-3,2-5.5,4.4-7.4,7.2c-1.7,2.6-2.6,5.3-2.6,8.1c0,2.7,1,5.1,3.1,7.4c2.3,2.6,5.3,4.8,8.8,6.7 c3.7,2,7.7,3.6,12,5c4.2,1.3,8.3,2.2,12.2,2.7c8.1,0.9,15.8,2.8,22.9,5.7c7.3,3,13.6,6.7,18.9,11.1c5.5,4.6,9.8,10,12.8,16 c3.1,6.1,4.7,12.8,4.7,20c0,7.3-1.6,14.2-4.8,20.7c-3.1,6.4-7.6,12-13.2,16.8c-5.6,4.6-12.1,8.4-19.3,11.2 C1263.8,434.2,1255.8,435.6,1247.5,435.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_390_",
    className: "st0",
    d: "M1357.6,435.6c-3.1,0-5.6-1.1-7.7-3.2c-2.1-2.1-3.2-4.7-3.2-7.7v-149c0-3,1.1-5.7,3.2-7.8 c2.1-2.1,4.7-3.2,7.7-3.2h91c3,0,5.7,1.1,7.7,3.2c2.1,2.1,3.2,4.7,3.2,7.8c0,3-1,5.6-3.2,7.7c-2.1,2.1-4.7,3.2-7.7,3.2h-80.1v52.2 h56.7c3,0,5.7,1.1,7.7,3.2c2.1,2.1,3.2,4.7,3.2,7.7c0,3-1.1,5.7-3.2,7.7c-2.1,2.1-4.7,3.2-7.7,3.2h-56.7v53.2h80.1 c3,0,5.6,1.1,7.7,3.2c2.1,2.1,3.2,4.8,3.2,7.8c0,3-1,5.6-3.2,7.7c-2.1,2.1-4.7,3.2-7.7,3.2H1357.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_389_",
    className: "st0",
    d: "M1603.2,435.6c-3,0-5.6-1.1-7.7-3.2c-2.1-2.1-3.2-4.7-3.2-7.7v-97.2c0-5.6-1-10.8-3.2-15.8 c-2.1-4.9-5.1-9.3-8.9-13.1c-3.8-3.8-8.2-6.7-13.1-8.9c-4.9-2.2-10.2-3.2-15.7-3.2c-5.6,0-10.9,1.1-15.8,3.2 c-4.9,2.1-9.3,5.1-12.9,8.9c-3.7,3.8-6.7,8.2-8.8,13.1c-2.1,5-3.2,10.3-3.2,15.8v97.2c0,3-1.1,5.6-3.2,7.7 c-2.1,2.1-4.7,3.2-7.7,3.2c-3,0-5.6-1.1-7.7-3.2c-2.1-2.1-3.2-4.7-3.2-7.7v-97.2c0-8.6,1.6-16.8,4.8-24.4 c3.3-7.7,7.8-14.4,13.4-20c5.7-5.7,12.3-10.2,19.9-13.5c7.6-3.3,15.8-5,24.4-5c8.6,0,16.8,1.7,24.4,5c7.5,3.2,14.2,7.7,19.9,13.4 c5.6,5.6,10.2,12.3,13.5,19.9c3.3,7.6,5,15.8,5,24.4v97.2c0,3-1.1,5.6-3.2,7.7C1608.8,434.5,1606.2,435.6,1603.2,435.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_388_",
    className: "st0",
    d: "M1710.5,435.6c-8.4,0-16.3-1.4-23.6-4c-7.3-2.7-13.9-6.4-19.4-11.2 c-5.6-4.7-10-10.4-13.2-16.7c-3.2-6.4-4.8-13.3-4.8-20.6c0-2.8,1-5.3,3-7.3c2-2,4.5-3.1,7.4-3.1c2.9,0,5.3,1,7.4,3 c2,2.1,3.1,4.5,3.1,7.4c0,4.3,1,8.4,3,12.1c2,3.8,4.8,7.2,8.3,10c3.6,2.9,7.9,5.2,12.8,6.9c4.9,1.7,10.3,2.5,15.9,2.5 c5.6,0,11-0.9,16-2.5c5-1.7,9.4-4,13.1-6.9c3.7-2.8,6.6-6.2,8.6-10c1.9-3.6,2.8-7.7,2.5-11.9c-0.3-4-1.6-7.7-3.7-11.1 c-2.2-3.5-5-6.7-8.6-9.5c-3.4-2.8-7.6-5.1-12.3-7c-4.5-1.8-9.4-3.2-14.6-4.1c-7.2-0.5-14.4-1.9-21.2-4.2c-6.8-2.3-12.9-5.3-18.1-9 c-5.2-3.7-9.5-8.1-12.7-13.1c-3.3-5.2-5-10.9-5-17.1c0-6.1,1.6-11.9,4.6-17.3c3.1-5.2,7.3-9.9,12.5-13.7 c5.2-3.8,11.3-6.9,18.2-9.2c6.9-2.2,14.3-3.4,22.1-3.4c7.8,0,15.2,1.1,22.1,3.4c6.9,2.3,13,5.3,18.2,9.2 c5.2,3.9,9.5,8.5,12.5,13.7c3.1,5.4,4.7,11.2,4.7,17.3c0,3-1.1,5.6-3.2,7.7c-2,2.1-4.6,3.2-7.7,3.2c-3.1,0-5.7-1.2-7.7-3.4 c-1.9-2-2.9-4.8-3.2-8.3c-0.2-2.6-1.1-5-2.8-7.3c-1.8-2.5-4.4-4.8-7.5-6.8c-3.2-2.1-7.1-3.7-11.4-4.9c-4.4-1.2-9-1.8-13.9-1.8 c-5,0-9.8,0.6-14.3,1.8c-4.4,1.2-8.2,2.8-11.4,4.9c-3.1,2-5.5,4.4-7.4,7.2c-1.8,2.6-2.6,5.3-2.6,8.1c0,2.7,1,5.1,3.1,7.4 c2.4,2.6,5.3,4.8,8.8,6.7c3.7,2,7.7,3.6,12,5c4.1,1.3,8.2,2.2,12.1,2.7c8.1,0.9,15.8,2.8,22.9,5.7c7.2,2.9,13.5,6.7,18.9,11.1 c5.4,4.5,9.7,9.9,12.8,15.9c3.1,6.2,4.7,12.9,4.7,20c0,7.3-1.6,14.2-4.8,20.7c-3.2,6.4-7.6,12-13.2,16.8 c-5.5,4.6-12.1,8.4-19.3,11.2C1726.8,434.2,1718.8,435.6,1710.5,435.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_387_",
    className: "st0",
    d: "M1874.9,435.6c-3,0-5.6-1.1-7.7-3.2c-2.1-2.1-3.2-4.7-3.2-7.7v-55.5l-67.2-86.8 c-1.8-2.2-2.7-5-2.4-7.9c0.2-2.8,1.5-5.4,3.8-7.3c2.1-1.7,4.4-2.5,7-2.5c3.8,0.3,6.3,1.6,8.2,3.9l61.5,79.1l62.7-79.1 c1.9-2.4,4.4-3.7,7.3-3.9h0.2c3.4,0,5.7,0.8,7.7,2.4c2.4,1.9,3.7,4.4,3.9,7.3c0.2,2.9-0.6,5.6-2.4,7.9l-68.5,86.8v55.5 c0,3-1.1,5.7-3.2,7.7C1880.5,434.5,1877.9,435.6,1874.9,435.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_386_",
    className: "st0",
    d: "M2039,435.6c-8.4,0-16.3-1.4-23.6-4c-7.3-2.7-13.8-6.4-19.4-11.2c-5.6-4.8-10-10.4-13.2-16.7 c-3.2-6.3-4.8-13.3-4.8-20.6c0-2.8,1-5.3,3-7.3c2-2,4.5-3.1,7.4-3.1c2.8,0,5.4,1,7.3,3.1c2,2,3,4.5,3,7.3c0,4.3,1,8.3,3,12.1 c2,3.8,4.8,7.1,8.4,10c3.5,2.8,7.8,5.1,12.7,6.8c4.9,1.7,10.2,2.5,15.9,2.5c5.6,0,11-0.9,16-2.5c5-1.7,9.4-4,13.1-6.9 c3.7-2.8,6.6-6.2,8.6-10c2-3.6,2.8-7.7,2.5-11.9c-0.3-3.9-1.6-7.7-3.7-11.1c-2.2-3.5-5.1-6.7-8.6-9.5c-3.5-2.8-7.6-5.1-12.3-7 c-4.5-1.8-9.5-3.2-14.6-4.1c-7.2-0.5-14.4-1.9-21.2-4.2c-6.8-2.3-12.9-5.3-18.1-9c-5.2-3.7-9.5-8.1-12.7-13.1 c-3.3-5.2-5-10.9-5-17.1c0-6.1,1.5-11.9,4.6-17.3c3-5.2,7.2-9.8,12.5-13.7c5.2-3.8,11.3-6.9,18.2-9.2c6.9-2.2,14.3-3.4,22.1-3.4 c7.8,0,15.2,1.1,22.1,3.4c6.9,2.3,13,5.4,18.1,9.2c5.3,3.9,9.5,8.5,12.5,13.7c3.1,5.4,4.6,11.2,4.6,17.3c0,3-1.1,5.6-3.2,7.7 c-2,2.1-4.6,3.2-7.7,3.2c-3.1,0-5.7-1.2-7.7-3.4c-1.9-2-3-4.8-3.2-8.3c-0.1-2.6-1-5-2.8-7.3c-1.9-2.6-4.3-4.8-7.6-6.8 c-3.2-2.1-7.1-3.7-11.4-4.9c-4.5-1.2-9-1.8-13.9-1.8c-5,0-9.8,0.6-14.3,1.8c-4.4,1.2-8.2,2.8-11.4,4.9c-3.1,2-5.5,4.4-7.4,7.2 c-1.8,2.6-2.6,5.3-2.6,8.1c0,2.7,1,5.1,3.1,7.4c2.4,2.6,5.3,4.8,8.8,6.7c3.7,2,7.7,3.6,12,5c4.2,1.3,8.3,2.2,12.1,2.7 c8.1,0.9,15.8,2.8,22.9,5.7c7.2,3,13.6,6.7,18.9,11.1c5.4,4.5,9.7,9.9,12.8,16c3.1,6.1,4.7,12.8,4.7,20c0,7.3-1.6,14.2-4.8,20.7 c-3.1,6.4-7.6,12-13.2,16.8c-5.5,4.6-12.1,8.4-19.3,11.2C2055.3,434.2,2047.3,435.6,2039,435.6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsensys);
export default __webpack_public_path__ + "static/media/consensys.fbc4e10be8100bbbbadf68bd1bfc2f5e.svg";
export { ForwardRef as ReactComponent };